import React from "react";
import { useSelector } from "react-redux";
import { networkTypeSelector } from "store/userSliceHelpers";
import "../index.css";
import "./merchant-layout.css";
import MerchantNav from "components/navbar/MerchantNav";

interface Props {
  children: React.ReactNode;
}

function MerchantLayout({ children }: Props) {
  const networkType = useSelector(networkTypeSelector);

  return (
    <div className="gp-layout">
      <div className="gp-layout-inner">
        <MerchantNav networkType={networkType} />
        <section className="gp-layout-content">{children}</section>
      </div>
      <div className="merchant-page__footer">
        © 2026 gardioPay · Merchant
      </div>
    </div>
  );
}

export default MerchantLayout;
